export { Territories } from './territories.component';
